__turbopack_context__.v({
  "iframe": "Video-module__bku3Pa__iframe",
  "video": "Video-module__bku3Pa__video",
  "wrapper": "Video-module__bku3Pa__wrapper",
});
